import { GridLayoutHeader } from '../../../../../constants';
import { FlexLayout } from '../../../../../components';
import { Format } from '../../../../../utils/string';
import { SalesModel } from '../models';
import { MonthConstruction } from '../MonthConstruction';

// 공사수주별
const Sales: GridLayoutHeader<SalesModel, MonthConstruction>[] = [
  {
    id: 'gubun',
    text: '코드',
    width: 3,
    render: (x, scope) => (
      <FlexLayout
        justify="center"
        align="center"
        style={scope?.getColotEvent(x.gubunnm)}
      >
        {x.gubun}
      </FlexLayout>
    ),
  },
  {
    id: 'gubunnm',
    text: '구분',
    width: 9,
    render: (x, scope) => (
      <FlexLayout
        justify="center"
        align="center"
        style={scope?.getColotEvent(x.gubunnm)}
      >
        {x.gubunnm}
      </FlexLayout>
    ),
  },
  {
    id: 'mon01',
    text: '1월',
    width: 6,
    render: (x, scope) => (
      <FlexLayout
        justify="right"
        align="center"
        style={scope?.getColotEvent(x.gubunnm)}
      >
        {Format.number(x.mon01)}
      </FlexLayout>
    ),
  },
  {
    id: 'mon02',
    text: '2월',
    width: 6,
    render: (x, scope) => (
      <FlexLayout
        justify="right"
        align="center"
        style={scope?.getColotEvent(x.gubunnm)}
      >
        {Format.number(x.mon02)}
      </FlexLayout>
    ),
  },
  {
    id: 'mon03',
    text: '3월',
    width: 6,
    render: (x, scope) => (
      <FlexLayout
        justify="right"
        align="center"
        style={scope?.getColotEvent(x.gubunnm)}
      >
        {Format.number(x.mon03)}
      </FlexLayout>
    ),
  },
  {
    id: 'mon04',
    text: '4월',
    width: 6,
    render: (x, scope) => (
      <FlexLayout
        justify="right"
        align="center"
        style={scope?.getColotEvent(x.gubunnm)}
      >
        {Format.number(x.mon04)}
      </FlexLayout>
    ),
  },
  {
    id: 'mon05',
    text: '5월',
    width: 6,
    render: (x, scope) => (
      <FlexLayout
        justify="right"
        align="center"
        style={scope?.getColotEvent(x.gubunnm)}
      >
        {Format.number(x.mon05)}
      </FlexLayout>
    ),
  },
  {
    id: 'mon06',
    text: '6월',
    width: 6,
    render: (x, scope) => (
      <FlexLayout
        justify="right"
        align="center"
        style={scope?.getColotEvent(x.gubunnm)}
      >
        {Format.number(x.mon06)}
      </FlexLayout>
    ),
  },
  {
    id: 'mon07',
    text: '7월',
    width: 6,
    render: (x, scope) => (
      <FlexLayout
        justify="right"
        align="center"
        style={scope?.getColotEvent(x.gubunnm)}
      >
        {Format.number(x.mon07)}
      </FlexLayout>
    ),
  },
  {
    id: 'mon08',
    text: '8월',
    width: 6,
    render: (x, scope) => (
      <FlexLayout
        justify="right"
        align="center"
        style={scope?.getColotEvent(x.gubunnm)}
      >
        {Format.number(x.mon08)}
      </FlexLayout>
    ),
  },
  {
    id: 'mon09',
    text: '9월',
    width: 6,
    render: (x, scope) => (
      <FlexLayout
        justify="right"
        align="center"
        style={scope?.getColotEvent(x.gubunnm)}
      >
        {Format.number(x.mon09)}
      </FlexLayout>
    ),
  },
  {
    id: 'mon10',
    text: '10월',
    width: 6,
    render: (x, scope) => (
      <FlexLayout
        justify="right"
        align="center"
        style={scope?.getColotEvent(x.gubunnm)}
      >
        {Format.number(x.mon10)}
      </FlexLayout>
    ),
  },
  {
    id: 'mon11',
    text: '11월',
    width: 6,
    render: (x, scope) => (
      <FlexLayout
        justify="right"
        align="center"
        style={scope?.getColotEvent(x.gubunnm)}
      >
        {Format.number(x.mon11)}
      </FlexLayout>
    ),
  },
  {
    id: 'mon12',
    text: '12월',
    width: 6,
    render: (x, scope) => (
      <FlexLayout
        justify="right"
        align="center"
        style={scope?.getColotEvent(x.gubunnm)}
      >
        {Format.number(x.mon12)}
      </FlexLayout>
    ),
  },
  {
    id: 'totmon',
    text: '합계',
    width: 6,
    render: (x) => (
      <FlexLayout
        justify="right"
        align="center"
        style={{ color: 'var(--color-blue)' }}
      >
        {Format.number(x.totmon)}
      </FlexLayout>
    ),
  },
  {
    id: 'aver',
    text: '평균',
    width: 10,
    render: (x) => (
      <FlexLayout
        justify="right"
        align="center"
        style={{ color: 'var(--color-blue)' }}
      >
        {Format.number(Math.round(Number(x.aver)))}
      </FlexLayout>
    ),
  },
];

export default Sales;
